import { StButton } from '@components/common';
import styled from 'styled-components';

const Toolbar = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 1em;
  column-gap: 1em;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1em;
`;

const TabList = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 0.5em;
`;

interface TabProps {
  selected: boolean;
}

const Tab = styled.button<TabProps>`
  background: transparent;
  border: 0;
  border-bottom: 2px solid ${(props) => (props.selected ? props.theme.colors.gistRed : 'transparent')};
  color: ${(props) => props.theme.colors.text};
  opacity: ${(props) => (props.selected ? 1 : 0.6)};
  font-family: Pretendard;
  font-size: 14px;
  font-weight: ${(props) => (props.selected ? 700 : 400)};
  padding: 0.5em 1em;
  cursor: pointer;
  :hover {
    opacity: 1;
    background-color: ${(props) => props.theme.colors.focus};
  }
`;

const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.5em;
  margin-left: auto;
`;

const SearchForm = styled.form`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.5em;
`;

const SearchInput = styled.input`
  background-color: transparent;
  color: ${(props) => props.theme.colors.text};
  font-family: Pretendard;
  font-size: 14px;
  border: 1px solid ${(props) => props.theme.colors.line};
  border-radius: 40px;
  padding: 11px 16px;
  outline: none;
  width: 220px;
  max-width: 40vw;
  ::placeholder {
    color: ${(props) => props.theme.colors.line};
  }
  :focus {
    border-color: ${(props) => props.theme.colors.gistRed};
  }
`;

interface vUserToolbarProps {
  roles: Array<string>;
  currentRole: string;
  searchInput: string;
  keyword: string;
  handleTabClick: (role: string) => void;
  handleSearchChange: React.ChangeEventHandler<HTMLInputElement>;
  handleSearchSubmit: React.FormEventHandler<HTMLFormElement>;
  handleSearchReset: () => void;
}

const VUserToolbar = ({
  roles,
  currentRole,
  searchInput,
  keyword,
  handleTabClick,
  handleSearchChange,
  handleSearchSubmit,
  handleSearchReset,
}: vUserToolbarProps): JSX.Element => {
  const tabs = [{ value: '', label: '전체' }, ...roles.map((role) => ({ value: role, label: role }))];
  return (
    <Toolbar>
      <TabList>
        {tabs.map((tab) => (
          <Tab
            key={`role_tab_${tab.value || 'all'}`}
            type="button"
            selected={currentRole === tab.value}
            onClick={() => handleTabClick(tab.value)}
          >
            {tab.label}
          </Tab>
        ))}
      </TabList>
      <Actions>
        <SearchForm onSubmit={handleSearchSubmit}>
          <SearchInput
            name="username"
            value={searchInput}
            onChange={handleSearchChange}
            placeholder="이메일로 검색"
            autoComplete="off"
          />
          <StButton type="submit">검색</StButton>
          {keyword ? (
            <StButton type="button" onClick={handleSearchReset}>
              초기화
            </StButton>
          ) : null}
        </SearchForm>
      </Actions>
    </Toolbar>
  );
};

export default VUserToolbar;
